import * as lib from "components/studio/board/nodes/Node.lib";
import { APP_URL } from "settings";
import l from "components/util/l";

const canExecuteNode = (nodes, edges, rootId, flowId) => {

    const byId = Object.create(null);
    const byRemote = Object.create(null);
    for (const n of nodes) {
        byId[n.id] = n;
        if (n.remoteId != null) byRemote[n.remoteId] = n;
        if (n.data?.remoteId != null) byRemote[n.data.remoteId] = n;
    }

    const rootNode = byRemote[rootId];
    if (!rootNode) return [false, ""];

    const adj = Object.create(null);
    for (const n of nodes) adj[n.id] = [];
    for (const e of edges) {
        if (!adj[e.source]) adj[e.source] = [];
        if (byId[e.target]) adj[e.source].push(e.target); // guardamos el id del hijo
    }

    const visited = new Set();     // negro
    const inStack = new Set();     // gris
    const nodesWithIssues = new Set(); // ids con errores/advertencias
    const cycleNodes = new Set();      // ids involucrados en ciclos

    const dfs = (id) => {
        if (inStack.has(id)) {        // back-edge => ciclo
            cycleNodes.add(id);
            return;
        }
        if (visited.has(id)) return;

        inStack.add(id);

        const node = byId[id];
        const errors = node?.data?.errors ?? [];
        const warnings = node?.data?.warnings ?? [];
        if (errors.length || warnings.length) nodesWithIssues.add(id);

        const children = adj[id] || [];
        for (const childId of children) dfs(childId);

        inStack.delete(id);
        visited.add(id);
    };

    dfs(rootNode.id);

    if (nodesWithIssues.size === 0 && cycleNodes.size === 0) return [true, ""];

    let errorMessage =
        `<p class="mb-0">${l("Antes de ejecutar revisa las siguientes acciones%SA232")}:</p>` +
        `<hr class="my-2" /><ul class="list-unstyled mt-3">`;
    let errorCount = 0;
    let warningCount = 0;

    for (const id of nodesWithIssues) {
        const n = byId[id];
        const action = { ...(n?.data?.action || {}) };
        const uiSettings = action.uiSettings;
        const errors = n?.data?.errors ?? [];
        const warnings = n?.data?.warnings ?? [];
        const editLink = `${APP_URL}/app/studio/${flowId}/flow/edit/${n.data?.remoteId ?? n.remoteId}`;

        for (const err of errors) {
            errorCount++;
            errorMessage += `
                <li>
                <div class="d-flex mb-2 ml-2">
                    <div class="mr-1"><i class="fa-solid fa-circle-xmark text-danger"></i></div>
                    <div><p class="mb-0 text-left">${lib.errorMapper(err, uiSettings)} <a href="${editLink}">Ver</a></p></div>
                </div>
                </li>`;
        }
        for (const warn of warnings) {
            warningCount++;
            errorMessage += `
                <li>
                <div class="d-flex mb-2 ml-2">
                    <div class="mr-1"><i class="fa-solid fa-triangle-exclamation text-warning"></i></div>
                    <div><p class="mb-0 text-left">${lib.warningMapper(warn, uiSettings)} <a href="${editLink}">Ver</a></p></div>
                </div>
                </li>`;
        }
    }

    errorMessage += `</ul>`;
    return [errorCount === 0 && warningCount === 0, errorMessage];
}


export { canExecuteNode }
